// Serviço centralizado para gerenciamento do localStorage
import { STORAGE_KEYS } from "../utils/constants";
import logger from "../../../utils/logger";

export const storageService = {
  /**
   * Salva dados do usuário no localStorage
   * @param {string} user - Nome de usuário
   * @param {string} password - Senha
   */
  setUser: (user, password) => {
    const userObject = JSON.stringify({ user, password });
    localStorage.setItem(STORAGE_KEYS.USER, userObject);
  },

  /**
   * Recupera dados do usuário do localStorage
   * @returns {Object|null} Objeto com user e password ou null
   */
  getUser: () => {
    const user = localStorage.getItem(STORAGE_KEYS.USER);
    if (!user) return null;
    
    try {
      return JSON.parse(user);
    } catch (error) {
      logger.error("Erro ao parsear dados do usuário", error);
      return null;
    }
  },

  /**
   * Salva o token de autenticação
   * @param {string} token - Token JWT
   */
  setToken: (token) => {
    localStorage.setItem(STORAGE_KEYS.TOKEN, token);
  },

  /**
   * Recupera o token de autenticação
   * @returns {string|null} Token ou null
   */
  getToken: () => {
    return localStorage.getItem(STORAGE_KEYS.TOKEN);
  },

  /**
   * Salva a região selecionada
   * @param {string} region - Região (RNO, RCO, RRD)
   */
  setRegion: (region) => {
    localStorage.setItem(STORAGE_KEYS.REGION, region);
  },

  /**
   * Recupera a região salva
   * @returns {string|null} Região ou null
   */
  getRegion: () => {
    return localStorage.getItem(STORAGE_KEYS.REGION);
  },

  /**
   * Salva o nome do usuário
   * @param {string} nameUser - Nome do usuário
   */
  setNameUser: (nameUser) => {
    localStorage.setItem(STORAGE_KEYS.NAME_USER, nameUser);
  },

  /**
   * Limpa dados antigos do localStorage antes de salvar novos dados de autenticação
   */
  clearOldData: () => {
    localStorage.removeItem(STORAGE_KEYS.REGISTER_PLOT_ALTERNATE);
    localStorage.removeItem(STORAGE_KEYS.UNIQUE_OCCURRENCES);
    localStorage.removeItem(STORAGE_KEYS.OCCURRENCES_SORT);
  },

  /**
   * Define o modo mock
   * @param {boolean} isMock - Se deve ativar modo mock
   */
  setMockMode: (isMock) => {
    if (isMock) {
      localStorage.setItem("isMockMode", "true");
      logger.info("Modo mock ativado no storage");
    } else {
      localStorage.removeItem("isMockMode");
      logger.info("Modo mock desativado no storage");
    }
  },

  /**
   * Verifica se está em modo mock
   * @returns {boolean} True se está em modo mock
   */
  isMockMode: () => {
    const mockMode = localStorage.getItem("isMockMode");
    return mockMode === "true";
  },

  /**
   * Remove flag de modo mock
   */
  clearMockMode: () => {
    localStorage.removeItem("isMockMode");
  },

  /**
   * Limpa todos os dados de autenticação
   */
  clearAuthData: () => {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER);
    localStorage.removeItem(STORAGE_KEYS.REGION);
    localStorage.removeItem(STORAGE_KEYS.NAME_USER);
    localStorage.removeItem(STORAGE_KEYS.ALL_PLOTS);
    localStorage.removeItem(STORAGE_KEYS.UNIQUE_OCCURRENCES);
    localStorage.removeItem(STORAGE_KEYS.OCCURRENCES_SORT);
    localStorage.removeItem(STORAGE_KEYS.REGISTER_PLOT_ALTERNATE);
    localStorage.removeItem(STORAGE_KEYS.REGISTERS_TO_INVITE);
    // Limpar modo mock
    localStorage.removeItem("isMockMode");
  }
};

